import { Typography } from '@mui/material';
import { Column } from 'new/elements/Table/types';
import { User } from 'new/entities/User';
import React from 'react';

export const columns = [
  {
    name: 'Member',
    field: 'name',
    renderRow: (row) => {
      return (
        <div>
          <Typography variant="subtitle2">{row.full_name}</Typography>
          <Typography variant="body3">{row.email}</Typography>
        </div>
      );
    },
  },
  {
    name: 'Company',
    field: 'org.name',
  },
  {
    name: 'Role',
    field: 'org.access_roles[0]',
  },
] as Column<User>[];
